export default "__VITE_ASSET__IpWEaX6o__"